import React from "react";

const BannerContext = React.createContext({});

export default BannerContext;
